import { Environment } from './../app/models/envarioment'
import { DevDev } from './suport/dev';
import { environment as oaprProd } from './suport/oapr'
// import { environment as doneITProd } from './suport/doneIt'


export const environment: Environment = DevDev;
